const dateTimeFormats = {
  en: {
    short: {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    },
    long: {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
  },
  de: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  hi: {
    short: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    },
    long: {
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  es: {
    short: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    },
    long: {
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
};

export default dateTimeFormats;
